import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-request-type',
  templateUrl: './request-type.component.html',
  styleUrls: ['./request-type.component.scss'],
})
export class RequestTypeComponent implements OnInit {
  showSelect = true;
  disableSelect = false;
  constructor(
    private readonly router: Router,
    private readonly activateRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.showSelect = this.activateRoute.snapshot.firstChild == null;
  }

  handleRequestChange(value: string) {
    this.disableSelect = true;
    this.router.navigate(['branch', 'request', value]);
  }
}
